import React from "react";
import icEye from "@/assets/icons/ic-eye.svg";
import icEyeOff from "@/assets/icons/ic-eye-off.svg";

interface PasswordFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  show: boolean;
  onToggle: () => void;
  error?: boolean;
}

export const PasswordField = React.forwardRef<HTMLInputElement, PasswordFieldProps>(
  ({ show, onToggle, error, className: _, maxLength, onChange, ...props }, ref) => (
    <div
      className={`flex items-center h-12 px-4 rounded-[4px] border border-[#00000027] ${error ? "ring-1 ring-[#D73D1D]" : ""}`}
    >
      <input
        type={show ? "text" : "password"}
        ref={ref}
        maxLength={maxLength}
        onChange={(e) => {
          if (maxLength && e.target.value.length > maxLength) {
            e.target.value = e.target.value.slice(0, maxLength);
          }
          onChange?.(e);
        }}
        {...props}
        className="flex-1 bg-transparent text-base leading-6 tracking-[-0.01em] text-content-strong font-bold placeholder:font-normal placeholder:text-[#B0B0B0] outline-none focus:outline-none focus:ring-0 [&:-webkit-autofill]:shadow-[0_0_0_30px_white_inset] [&:-webkit-autofill]:[-webkit-text-fill-color:black]"
        autoComplete="new-password"
      />
      <button
        type="button"
        onClick={onToggle}
        className="ml-2 flex-shrink-0"
        aria-label={show ? "비밀번호 숨기기" : "비밀번호 보기"}
      >
        <img src={show ? icEyeOff : icEye} alt="" width={24} height={24} />
      </button>
    </div>
  ),
);
